module.exports = __webpack_public_path__ + "img/zimm-filter.330009cd.png";